<template>
  <div>
    <!-- <p class="font-weight-bold">
      <ConsoleLink to="/product-variable" class="text-primary">
        {{ $t('sideBar.product_variable') }} >
      </ConsoleLink> Edit {{ $t('sideBar.product_variable') }}
    </p> -->

    <a-breadcrumb separator=">">
      <a-breadcrumb-item>
        <ConsoleLink to="/product-variable" class="text-primary">
          {{ $t('sideBar.product_variable') }}
        </ConsoleLink>
      </a-breadcrumb-item>
      <a-breadcrumb-item>
        {{ $t('utils.edit') }} {{ $t('sideBar.product_variable') }}
      </a-breadcrumb-item>
    </a-breadcrumb>

    <EditProductVariable :permission="permission" />
  </div>
</template>

<script>
import EditProductVariable from '@/components/Price/Product-Variable/Edit'
import ConsoleLink from '@/components/ConsoleLink/ConsoleLink.vue'

export default {
  components: {
    EditProductVariable,
    ConsoleLink,
  },
  computed: {
    permission() {
      return this.$store.getters['user/can']('product-variable')
    },
  },
  // watch: {
  //   permission(newValue) {
  //     if(!newValue.length || !newValue.includes('WRITE')) {
  //       this.$router.push({path: '/error/403', query: {...this.$route.query}})
  //     }
  //   },
  // },
}
</script>
